module.exports = __webpack_public_path__ + "static/media/apricot_compote.90d0c8ab.png";